import React from "react"
import cookie from "react-cookies"
import queryString from 'query-string'
import { Redirect } from "react-router-dom"
import { Helmet } from "react-helmet"

import { getCity, getCityWithDriver } from "../../model/common"
import Header from "../components/header"
import Footer from "../components/footer"
import Cover from "../landingpage/cover"
import FeatureCars from "./featurecars"

import DealCars from "./dealcars"
// import FeatureDes from "./featuredes"

import Review from "./review"

import Explorer from "../landingpage/explorer"
import AboutUs from "../landingpage/aboutus"
import AppAds from "../landingpage/appads"
import Blogs from "../landingpage/blogs"

import { stypes } from "../common/common"
import { commonErr } from "../common/errors"
import { LoadingPage } from "../common/loading"

import { HiddenCityLink } from "../common/hiddenlink"

class City extends React.Component {
    constructor() {
        super();
        this.state = {
            err: commonErr.INNIT
        }
    }

    componentDidMount() {
        const city = this.props.match.params.city;

        //GA
        if (this.props.location && this.props.location.search) {
            const query = queryString.parse(this.props.location.search);
            if (query.utm_source) {
                cookie.save("_utm_src", query.utm_source, { path: '/' });
                cookie.save("_utm_src", query.utm_source, { path: '/', domain: '.mioto.vn' });
            }
            if (query.utm_campaign) {
                cookie.save("_utm_campaign", query.utm_campaign, { path: '/' });
                cookie.save("_utm_campaign", query.utm_campaign, { path: '/', domain: '.mioto.vn' });
            }
            if (query.utm_medium) {
                cookie.save("_utm_medium", query.utm_medium, { path: '/' });
                cookie.save("_utm_medium", query.utm_medium, { path: '/', domain: '.mioto.vn' });
            }
            if (query.utm_term) {
                cookie.save("_utm_term", query.utm_term, { path: '/' });
                cookie.save("_utm_term", query.utm_term, { path: '/', domain: '.mioto.vn' });
            }
            if (query.utm_ext) {
                cookie.save("_utm_ext", query.utm_ext, { path: '/' });
                cookie.save("_utm_ext", query.utm_ext, { path: '/', domain: '.mioto.vn' });
            } else {
                cookie.remove("_utm_ext", { path: '/' });
                cookie.remove("_utm_ext", { path: '/', domain: '.mioto.vn' });
            }
        }
        if (this.props.match.url.includes("withdriver")) {
            getCityWithDriver(city).then(resp => {
                if (resp.data.data) {
                    this.setState({
                        err: resp.data.error,
                        city: resp.data.data.city,
                        dealArounds: resp.data.data.dealArounds,
                        featureCars: resp.data.data.featureCars,
                        destArounds: resp.data.data.destArounds,
                        reviews: resp.data.data.reviews,
                        moreReview: resp.data.data.moreReview,
                        profiles: resp.data.data.profiles,
                    })
                } else {
                    this.setState({
                        err: resp.data.error
                    })
                }
            });
        }
        else {
            getCity(city).then(resp => {
                if (resp.data.data) {
                    this.setState({
                        err: resp.data.error,
                        city: resp.data.data.city,
                        dealArounds: resp.data.data.dealArounds,
                        featureCars: resp.data.data.featureCars,
                        destArounds: resp.data.data.destArounds,
                        reviews: resp.data.data.reviews,
                        moreReview: resp.data.data.moreReview,
                        profiles: resp.data.data.profiles,
                    })
                } else {
                    this.setState({
                        err: resp.data.error
                    })
                }
            });
        }
        const utmSrc = cookie.load("_utm_src") || "web_directly";
        const utmExt = cookie.load("_utm_ext") || "no_label";
     
        window.gtag('event', "VIEW_CITY", {
			event_category: utmSrc,
			event_label: utmExt,
            campaign: {source: utmSrc}
		});
        window.fbq('track', "VIEW_CITY");
    }

    render() {
        const stype = this.props.match.url.includes("withdriver") ? stypes.WD : stypes.SD;
        const { err, city, dealArounds, featureCars, reviews, destArounds, profiles, moreReview } = this.state;

        if (err < commonErr.SUCCESS) {
            return <Redirect to="/notfound" />
        } else if (err === commonErr.INNIT) {
            return <LoadingPage />
        } else {
            return (
                <React.Fragment>
       
                <Helmet>
                    <title>{`${city.metaTitle} | MIOTO`}</title>
					<meta name="description" content={city.metaDesc} />
                    <meta name="keywords" content="thuê xe tự lái tphcm, thuê xe du lịch, xe du lịch, thue xe du lich, thue xe du lịch, thue xe tu lai 7 cho, thuê xe ô tô tự lái tphcm, thuê ô tô tự lái tphcm, thue xe tu lai tphcm, dịch vụ cho thuê xe, dich vu cho thue xe, dich vu cho thue xe, xe tự lái, dịch vụ thuê xe tự lái, giá thuê xe tự lái, dịch vụ thuê xe, cho thuê xe ô tô tự lái, dịch vụ thuê ô tô tự lái, dich vu cho thue xe tu lai tai tphcm, thuê xe hà nội, cho thuê xe tự lái tphcm, thuê lái xe, thue xe ô tô, xe du lich, cho thuê xe tự lái gần đây, thuê xe du lịch tại hà nội" />
                </Helmet> 
                  
                <div className="mioto-layout">
                    <HiddenCityLink />
                    <Header notLineHeader={true} />
                        {city && <section className="body">
                            <Cover city={city} stype={stype} />
                            
                            {featureCars && <FeatureCars city={city.name} cars={featureCars} stype={stype} />}
                            {dealArounds && <DealCars city={city.name} cars={dealArounds} stype={stype} />}
                            {reviews && <Review city={city} reviews={reviews} profiles={profiles} hasMore={moreReview} />}
                            {/* {destArounds && <FeatureDes city={city.name} des={destArounds} />} */}
                            <AboutUs />
                            <Explorer />
                            <AppAds />
                            <Blogs city={city.city} />
                        </section>}
                    <Footer />
                </div>
                </React.Fragment>
            )
}
    }
}

export default City;